import { SearchItemUserImage } from 'api/search/search.types'
import { PHOTO_SIZES } from 'components/page/Search/searchPromoFunctions'

export const createImageSet = (userpic: SearchItemUserImage) => {
  if (userpic.id === 0) {
    return
  }

  return {
    [PHOTO_SIZES.SQUARE.ID]: userpic.square,
    [PHOTO_SIZES.SQUARE_LARGE.ID]: userpic.squareLarge + ' 2x',
    [PHOTO_SIZES.SQUARE_SMALL.ID]: userpic.squareSmall,
  }
}
